import { CheckCircle2 } from "lucide-react";
import { AudioCell } from "./AudioCell";
import { RatingBadge } from "./dashboard/FeedbackTable";
import { fmtDate } from "../lib/constants";

export const FeedbackCard = ({ i, onResolve, prefix }) => (
  <div data-testid={`${prefix}-card-${i.id}`} className="glass rounded-3xl p-5 flex flex-col gap-3 rise">
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <div className="font-display text-lg font-extrabold text-emerald-950 truncate">{i.guest_name}</div>
        <div className="text-xs text-slate-500">{i.hotel} · {i.category} · {fmtDate(i.visit_date)}</div>
        {i.mobile && <div className="text-xs text-slate-500">{i.mobile}</div>}
      </div>
      <RatingBadge r={i.rating} />
    </div>
    {i.remarks && <p className="text-sm text-slate-700">“{i.remarks}”</p>}
    {i.ai_summary && <p className="text-xs rounded-xl bg-amber-50 border border-amber-100 p-2.5 text-amber-900"><span className="font-semibold">AI: </span>{i.ai_summary}</p>}
    {i.topics.length > 0 && <div className="flex flex-wrap gap-1">{i.topics.map((t) => <span key={t} className="rounded-full bg-slate-100 px-2 py-0.5 text-[11px] text-slate-600">{t}</span>)}</div>}
    {i.status === "Resolved" && i.resolution_remarks && (
      <p className="text-xs rounded-xl bg-emerald-50 border border-emerald-100 p-2.5 text-emerald-900"><span className="font-semibold">Resolved: </span>{i.resolution_remarks}{i.resolved_by_name ? ` — ${i.resolved_by_name}` : ""}</p>
    )}
    <div className="mt-auto flex items-center justify-between gap-2 pt-2">
      <AudioCell id={i.id} audio={i.audio} testId={`${prefix}-audio-${i.id}`} />
      {i.status === "Pending" ? (
        <button data-testid={`${prefix}-resolve-${i.id}`} onClick={() => onResolve(i)} className="inline-flex items-center gap-2 rounded-full bg-emerald-900 px-4 py-2 text-sm font-semibold text-amber-50 hover:bg-emerald-800 transition-colors">
          <CheckCircle2 className="h-4 w-4" /> Resolve
        </button>
      ) : (
        <span data-testid={`${prefix}-status-${i.id}`} className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs font-semibold text-emerald-700"><CheckCircle2 className="h-3.5 w-3.5" /> Resolved</span>
      )}
    </div>
  </div>
);
